import { Auth } from 'aws-amplify'
import { retryApiCall } from '../utilities/retry'

const baseUrl = window.Pura?.environment?.production
  ? 'https://trypura.io/mobile/api'
  : 'https://staging.trypura.io/mobile/api'

export async function callMultipass(
  cognitoToken: string,
  return_to_url: string,
  maxRetries: number = 3
) {
  const result = await retryApiCall(
    async (token: string) => {
      const response = await fetch(`${baseUrl}/multipass`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({ cognito_token: token, return_to_url }),
      })

      if (response.status === 401) {
        const errorText = await response
          .text()
          .catch(() => 'Unable to read error')

        const error = new Error(
          `Authentication failed: ${response.status} - ${errorText}`
        )
        ;(error as any).status = 401
        throw error
      }

      if (!response.ok) {
        const errorText = await response
          .text()
          .catch(() => 'Unable to read error')
        throw new Error(
          `Multipass API error: ${response.status} - ${errorText}`
        )
      }

      return await response.json()
    },
    async () => cognitoToken,
    async () => {
      const session = await Auth.currentSession()
      const newToken = session.getIdToken().getJwtToken()
      return newToken
    },
    maxRetries
  )

  if (!result.success) {
    throw result.error
  }

  return result.result
}
